import axios from 'axios';
import { ROUTE_PATHS } from '../routes/Routes';
import { REDIRECT_PATH_AFTER_LOGIN } from './consts';
import qs from 'qs';

const CustomAxios = axios.create({
  withCredentials: true,
  baseURL: process.env.REACT_APP_BASE_URL || 'http://localhost:3000/api',
  headers: {
    'Content-Type': 'application/json',
  },
  paramsSerializer: (params) => {
    return qs.stringify(params, { arrayFormat: 'brackets' });
  },
});

CustomAxios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      const { pathname = '', search = '' } = window.location;
      sessionStorage.setItem(REDIRECT_PATH_AFTER_LOGIN, `${pathname + search}`);

      window.location.href = ROUTE_PATHS.LOGIN;
    } else if (error.response.status === 400) {
      throw new Error(error.response.data.error);
    } else {
      return Promise.reject(error);
    }
  }
);

export default CustomAxios;
